// New Account-First Signup Flow (Testing Route)
// This will replace the old SignupWithElements component

import React from 'react';
import SignupFlowContainer from './SignupFlow/SignupFlowContainer';

const SignupNew: React.FC = () => {
  return <SignupFlowContainer />;
};

export default SignupNew;